/*
 * Created by: cparaschiv
 * Date: 02.07.2014, 10:52 
 */

TS.ns('TS.data');

(function ($) {
    'use strict';
    
    var ui = kendo.ui,
        TreeList = ui.TreeList,
        TreeListDataSource = kendo.data.TreeListDataSource,

        BindingListSelectionMode = {
            get Simple() {
                return "row";
            },
            get Multiple() {
                return "multiple, row";
            },
            get Cell() {
                return "multiple, cell";
            },
            get SingleCell() {
                return "cell";
            }
        };


    //region TsTreeListDataSource

    TS.data.TsTreeListDataSource = TreeListDataSource.extend({

        init: function (options) {
            var dataSource = options.dataSource,
                modelConfig = {};

            if (dataSource) {
                options.transport = dataSource.getHierarchyProvider();
                modelConfig = $.extend(true, {}, modelConfig, dataSource.getHierarchyFields());
            }

            this.TreeListModel = kendo.data.Model.define(kendo.data.TreeListModel, modelConfig);

            TreeListDataSource.fn.init.call(this, $.extend(true, {}, {
                schema: {
                    modelBase: this.TreeListModel,
                    model: this.TreeListModel
                }
            }, options));
        }

    });

    //endregion

    function buildWidgetDataSource(dataSource) {
        var koDs, opts;

        opts = {
            dataSource: dataSource
        };
        koDs = new TS.data.TsTreeListDataSource(opts);

        return koDs;
    };

    var TsTreeList = TreeList.extend({

        options: {
            name: "TsTreeList"
        },

        init: function (element, options) {
            var me = this;

            options.dataSource = me._setDataSource(options);
            options.selectable = BindingListSelectionMode[ko.valueOf(me.DataSource.SelectionMode)] || true;
            options.change = $.proxy(this._onTreeSelectionChange, this);
            options.columns = me._buildColumns(options);
            //options.toolbar = me._buildToolbar(blp.commands, blp.name);

            TreeList.fn.init.call(this, element, options);

            //me.element.delegate("tbody>tr", "dblclick", $.proxy(me._onDblClick, me));

            //disable browser selection
            me.wrapper.on('selectstart', false);
        },

        _setDataSource: function (options) {
            var me = this,
                dataSource = options.DataSource;

            if (!dataSource) {
                return;
            }

            dataSource.un('propertyChanged', me._onDataSourcePropertyChanged);
            dataSource.on('propertyChanged', me._onDataSourcePropertyChanged, me);
            //dataSource.on('selectedItemChanged', me._onSelectedItemChanged, me);

            me.DataSource = dataSource;
            me.dataSource = buildWidgetDataSource(dataSource);

            return me.dataSource;
        },

        //region Columns

        _buildColumn: function (field, column, options) {
            var me = this;
            column = column || {};
            options = options || column.options || {};
            column.options = options;

            column.name = options.Name || field.Name;
            column.FieldName = field.Name;
            column.field = ko.valueOf(field.DisplayPropertyName) || ko.valueOf(field.PropertyName);
            column.title = ko.valueOf(options.Title || field.Title) || "";
            column.width = ko.valueOf(options.Width || field.Width) || "";

            column.format = ko.valueOf(field.Format);
            if (field.type == 'numeric') {
                column.format = TS.Util.kendoNumericFormat(ko.valueOf(field.DecimalPrecision), ko.valueOf(field.UseThousandSeparator));
            }
            column.hidden = options.Visible === false || ko.valueOf(field.Visible) === false;
            column.locked = !!options.Frozen || ko.valueOf(field.Frozen) === true;

            column.resizable = ko.valueOf(field.AllowResize);
            column.sortable = ko.valueOf(field.AllowSort);
            column.editable = !ko.valueOf(field.ReadOnly);
            column.type = field.getEditorType();
            column.owner = me;

            column.template = TsTreeList.ColumnTemplates.template();
            var headerAttributes = TsTreeList.ColumnTemplates.headerAttributes(column);
            if (headerAttributes) {
                column.headerAttributes = headerAttributes;
            }
            return column;
        },

        _buildColumns: function (options) {
            var me = this,
                dataSource = options.DataSource,
                fields = ko.valueOf(dataSource.Fields),
                columns = [];
            if (options.Columns) {
                $.each(options.Columns, function (key, column) {
                    column.Name = column.Name || key;
                    var field = dataSource.Fields[column.FieldName || column.Name];
                    if (field) {
                        column = me._buildColumn(field, null, column);
                        if (column) {
                            columns.push(column);
                        }
                    }
                });
            }
            if (options.AutoCreateColumns !== false) {
                $.each(fields, function (index, field) {
                    var column = me._buildColumn(field);
                    if (column) {
                        columns.push(column);
                    }
                });
            }
            return columns;
        },

        //endregion

        //region Events Handlers

        _onDataSourcePropertyChanged: function (args) {
            if (args.propertyName === 'Selection') {

            }
        },

        //region SelectionChange

        _onDataSourceSelectionChange: function (e) {

            //var row = this.tbody.find("[" + kendo.attr("uid") + "=" + model.uid + "]");
            var selectable = kendo.ui.Selectable.parseOptions(this.options.selectable);
            if (selectable.cell) {
                //cells example
                var selectedCells = this.select();
                var selectedDataItems = [];
                for (var i = 0; i < selectedCells.length; i++) {
                    var dataItem = this.dataItem(selectedCells[i].parentNode);
                    if ($.inArray(dataItem, selectedDataItems) < 0) {
                        selectedDataItems.push(dataItem);
                    }
                }
            }
            else {
                //rows example
                var selectedRows = this.select();
                var selectedDataItems = [];
                for (var i = 0; i < selectedRows.length; i++) {
                    var dataItem = this.dataItem(selectedRows[i]);
                    selectedDataItems.push(dataItem);
                }
            }
        },

        _onTreeSelectionChange: function (e) {
            var me = this,
                selectable = kendo.ui.Selectable.parseOptions(this.options.selectable),
                selection = [];
            if (selectable.cell) {
                //cells example
                var selectedCells = this.select();
                for (var i = 0; i < selectedCells.length; i++) {
                    var selectedCell = selectedCells[i],
                        selectedRow = selectedCell.parentNode,
                        selectedCellIndex = $("td", selectedRow).index(selectedCell),
                        selectedColumn;

                    if (me._hasLockedColumns) {
                        var table = $(selectedCell).closest('table'),
                            specificColumnIndex = -1,
                            isLocked = table.is(me.lockedTable);
                        $.each(me.columns, function (index, column) {
                            if(isLocked === (column.locked === true)){
                                specificColumnIndex ++;
                            }
                            if(specificColumnIndex === selectedCellIndex){
                                selectedColumn = column;
                                return false;
                            }
                        });
                    }else {
                        selectedColumn = this.columns[selectedCellIndex];
                    }

                    var dataItem = this.dataItem(selectedCells[i].parentNode);
                    if ($.inArray(dataItem, selection) < 0) {
                        selection.push({data: dataItem, fields:[]});
                    }
                }
            }
            else {
                //rows example
                var selectedRows = this.select();
                for (var i = 0; i < selectedRows.length; i++) {
                    var dataItem = this.dataItem(selectedRows[i]);
                    selection.push(dataItem);
                }
            }
        }

        //endregion

        //endregion

    });

    TsTreeList.ColumnTemplates = TS.UI.ColumnTemplates;

    ui.plugin(TsTreeList);

    ko.bindingHandlers['TsTreeList'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var config = valueAccessor(),
                options = {},
                $element;

            Object.append(options, config);
            options.DataSource = ts.getPropertyValue(bindingContext.$data, config.EditValue);
            //if (editable == false) {
            //	dataSource.disableEditing();
            //}
            $element = $(element);
            if (!options.DataSource) {
                TS.Log.error("Error: Invalid data source " + config.dataSource + " for tree " + $element.attr('id'));
                return;
            }

            $element.kendoTsTreeList(options/*{
             DataSource: dataSource,
             selectable: selectionmode,
             editable: editable,
             resizable: true,
             sortable: {
             mode: "multiple",
             allowUnsort: true
             }
             }*/);
        }
    };
})(jQuery);
